// @generated by TypeGen from NMEA/N2K/N2KLookups.swift - DO NOT EDIT

export enum IN2KAGSGeneratingState {
  preheating = 0,
  startDelay = 1,
  cranking = 2,
  starterCooling = 3,
  warmingUp = 4,
  coolingDown = 5,
  spinningUp = 6,
  shutdownBypass = 7,
  stopping = 8,
  running = 9,
  stopped = 10,
  crankDelay = 11,
}

export enum IN2KAGSMode {
  off = 0,
  on = 1,
  automatic = 2,
}

export enum IN2KAGSOffReason {
  notOff = 0,
  dcVoltageHigh = 1,
  batteryStateOfChargeHigh = 2,
  acCurrentLow = 3,
  contactOpened = 4,
  reachedAbsorption = 5,
  reachedFloat = 6,
  manualOff = 7,
  maxRunTime = 8,
  maxAutoCycle = 9,
  exerciseDone = 10,
  quietTime = 11,
  externalOffViaAGS = 12,
  safeMode = 13,
  externalOffViaGenerator = 14,
  externalShutdown = 15,
  autoOff = 16,
  fault = 17,
  unableToStart = 18,
}

export enum IN2KAGSOnReason {
  notOn = 0,
  dcVoltageLow = 1,
  batteryStateOfChargeLow = 2,
  acCurrentHigh = 3,
  contactClosed = 4,
  manualOn = 5,
  exercise = 6,
  nonQuietTime = 7,
  externalOnViaAGS = 8,
  externalOnViaGenerator = 9,
  unableToStop = 10,
}

export enum IN2KAGSOperatingState {
  quietTime = 0,
  autoOn = 1,
  autoOff = 2,
  manualOn = 3,
  manualOff = 4,
  generatorShutdown = 5,
  externalShutdown = 6,
  fault = 7,
  suspend = 8,
  notOperating = 9,
}

export enum IN2KAlertCategory {
  navigational = 0,
  technical = 1,
}

export enum IN2KAlertResponseCommand {
  acknowledge = 0,
  temporarySilence = 1,
  testCommandOff = 2,
  testCommandOn = 3,
}

export enum IN2KAlertState {
  disabled = 0,
  normal = 1,
  active = 2,
  silenced = 3,
  acknowledged = 4,
  awaitingAcknowledge = 5,
}

export enum IN2KAlertThresholdStatus {
  normal = 0,
  thresholdExceeded = 1,
  extremeThresholdExceeded = 2,
  lowThresholdExceeded = 3,
  acknowledged = 4,
  awaitingAcknowledge = 5,
}

export enum IN2KAlertTriggerCondition {
  manual = 0,
  auto = 1,
  test = 2,
  disabled = 3,
}

export enum IN2KAlertType {
  emergencyAlarm = 1,
  alarm = 2,
  warning = 5,
  caution = 8,
}

export enum IN2KBatteryChemistry {
  leadAcid = 0,
  lithium = 1,
  nickelCadmium = 2,
  zincOxide = 3,
  nickelMetalHydride = 4,
}

export enum IN2KBatteryNominalVoltage {
  v6 = 0,
  v12 = 1,
  v24 = 2,
  v32 = 3,
  v36 = 4,
  v42 = 5,
  v48 = 6,
}

export enum IN2KBatteryType {
  flooded = 0,
  gel = 1,
  agm = 2,
}

export enum IN2KChargerMode {
  standalone = 0,
  primary = 1,
  secondary = 2,
  echo = 3,
}

export enum IN2KChargerState {
  notCharging = 0,
  bulk = 1,
  absorption = 2,
  overcharge = 3,
  equalise = 4,
  float = 5,
  noFloat = 6,
  constantVI = 7,
  disabled = 8,
  fault = 9,
}

export enum IN2KDCType {
  battery = 0,
  alternator = 1,
  converter = 2,
  solarCell = 3,
  windGenerator = 4,
}

export enum IN2KDSCCategory {
  routine = 100,
  safety = 108,
  urgency = 110,
  distress = 112,
}

export enum IN2KDirectionReference {
  trueNorth = 0,
  magnetic = 1,
  error = 2,
}

export enum IN2KDockingStatus {
  notDocked = 0,
  fullyDocked = 1,
}

export enum IN2KGearStatus {
  forward = 0,
  neutral = 1,
  reverse = 2,
}

export enum IN2KInverterMode {
  standalone = 0,
  seriesMaster = 1,
  seriesSlave = 2,
  parallelMaster = 3,
  parallelSlave = 4,
}

export enum IN2KInverterState {
  invert = 0,
  acPassthru = 1,
  loadSense = 2,
  fault = 3,
  disabled = 4,
}

export enum IN2KOffOn {
  off = 0,
  on = 1,
}

export enum IN2KRodeType {
  chain = 0,
  rope = 1,
}

export enum IN2KRudderDirection {
  noOrder = 0,
  moveToStarboard = 1,
  moveToPort = 2,
}

export enum IN2KSteeringMode {
  mainSteering = 0,
  nonFollowUpDevice = 1,
  followUpDevice = 2,
  headingControlStandalone = 3,
  headingControl = 4,
  trackControl = 5,
}

export enum IN2KTankType {
  fuel = 0,
  water = 1,
  grayWater = 2,
  liveWell = 3,
  oil = 4,
  blackWater = 5,
}

export enum IN2KTurnMode {
  rudderLimitControlled = 0,
  turnRateControlled = 1,
  radiusControlled = 2,
}

export enum IN2KWindReference {
  trueNorth = 0,
  magneticNorth = 1,
  apparent = 2,
  trueBoat = 3,
  trueWater = 4,
}

export enum IN2KWindlassDirection {
  off = 0,
  down = 1,
  up = 2,
}

export enum IN2KWindlassMotion {
  stopped = 0,
  deploying = 1,
  retrieving = 2,
}

export enum IN2KYesNo {
  no = 0,
  yes = 1,
}
